import type { ReactNode } from 'react';

export const symbol_villa: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-180v-421q0-18.67 10.43-33.97Q140.86-650.28 158-657l436-168q15-6 28 3.07 13 9.06 13 24.93v317h85q0-24.75 17.68-42.38Q755.35-540 780.18-540q24.82 0 42.32 17.62Q840-504.75 840-480v300q0 24.75-17.62 42.37Q804.75-120 780-120H180q-24.75 0-42.37-17.63Q120-155.25 120-180Zm60 0h190v-240q0-24.75 17.63-42.38Q405.25-480 430-480h145v-273L180-601v421Zm250 0h145v-80q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v80h145v-240H430v240Zm-52-287Zm227 167Zm0 0Z"
		/>
	</svg>
);
